// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_body__M\\+3rf {
  display: inline-block;
  max-width: none;
  max-height: none;
  width: auto;
  height: auto; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Popover/styles.module.scss"],"names":[],"mappings":"AACA;EACI,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY,EAAA","sourcesContent":["@import \"src/modules/Core/styles/mixins.scss\";\n.body {\n    display: inline-block;\n    max-width: none;\n    max-height: none;\n    width: auto;\n    height: auto;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `styles_body__M+3rf`
};
export default ___CSS_LOADER_EXPORT___;
